require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.MagicGrid = e();
}(this, function () {
  "use strict";

  var t = function t(_t) {
    if (!_t) throw new Error("No config object has been provided.");
    "boolean" != typeof _t.useTransform && (_t.useTransform = !0), "number" != typeof _t.gutter && (_t.gutter = 25), _t.container || e("container"), _t.items || _t["static"] || e("items or static");
  },
      e = function e(t) {
    throw new Error("Missing property '" + t + "' in MagicGrid config");
  },
      i = function i(t) {
    var e = t[0];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var i = _step.value;
        i.height < e.height && (e = i);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return e;
  },
      n = function n(e) {
    t(e), e.container instanceof HTMLElement ? (this.container = e.container, this.containerClass = e.container.className) : (this.containerClass = e.container, this.container = document.querySelector(e.container)), this.items = this.container.children, this["static"] = e["static"] || !1, this.size = e.items, this.gutter = e.gutter, this.maxColumns = e.maxColumns || !1, this.useMin = e.useMin || !1, this.useTransform = e.useTransform, this.animate = e.animate || !1, this.started = !1, this.init();
  };

  return n.prototype.init = function () {
    if (this.ready() && !this.started) {
      this.container.style.position = "relative";

      for (var t = 0; t < this.items.length; t++) {
        var e = this.items[t].style;
        e.position = "absolute", this.animate && (e.transition = (this.useTransform ? "transform" : "top, left") + " 0.2s ease");
      }

      this.started = !0;
    }
  }, n.prototype.colWidth = function () {
    return this.items[0].getBoundingClientRect().width + this.gutter;
  }, n.prototype.setup = function () {
    var t = this.container.getBoundingClientRect().width,
        e = this.colWidth(),
        i = Math.floor(t / e) || 1,
        n = [];
    this.maxColumns && i > this.maxColumns && (i = this.maxColumns);

    for (var s = 0; s < i; s++) {
      n[s] = {
        height: 0,
        index: s
      };
    }

    return {
      cols: n,
      wSpace: t - i * e + this.gutter
    };
  }, n.prototype.nextCol = function (t, e) {
    return this.useMin ? i(t) : t[e % t.length];
  }, n.prototype.positionItems = function () {
    var t = this.setup(),
        e = t.cols,
        i = t.wSpace,
        n = 0,
        s = this.colWidth();
    i = Math.floor(i / 2);

    for (var o = 0; o < this.items.length; o++) {
      var r = this.nextCol(e, o),
          a = this.items[o],
          h = r.height ? this.gutter : 0,
          c = r.index * s + i + "px",
          u = r.height + h + "px";
      this.useTransform ? a.style.transform = "translate(" + c + ", " + u + ")" : (a.style.top = u, a.style.left = c), r.height += a.getBoundingClientRect().height + h, r.height > n && (n = r.height);
    }

    this.container.style.height = n + "px";
  }, n.prototype.ready = function () {
    return !!this["static"] || this.items.length >= this.size;
  }, n.prototype.getReady = function () {
    var t = this,
        e = setInterval(function () {
      t.container = document.querySelector(t.containerClass), t.items = t.container.children, t.ready() && (clearInterval(e), t.init(), t.listen());
    }, 100);
  }, n.prototype.listen = function () {
    var t = this;

    if (this.ready()) {
      var e;
      window.addEventListener("resize", function () {
        e || (e = setTimeout(function () {
          t.positionItems(), e = null;
        }, 200));
      }), this.positionItems();
    } else this.getReady();
  }, n;
});